import { ImageBackground, Pressable, ScrollView, View, Text ,Image, Platform} from 'react-native';
import { themeColorSet, ThemedText, ThemedView, themeTextVariants } from '@app/theme';
import Button from '@app/sharedComponents/Button/Button';
import { formatIndianCurrency } from '@app/utils/utility';
import ROUTE from '@app/navigationApp/routes';
import {LENDER_DISPLAY_NAME_MAP} from '@app/constants/platformPartners';
import TataLogo from '../../../../assets/Icons/TataLogo';
import DSPLogo from '../../../../assets/Icons/DSPLogo';
import BajajLogo from '../../../../assets/Icons/BajajLogo';
import { CaretRight } from '@app/sharedComponents/Icons/Icons';
import { useAppSelector } from '@app/store/hooks';
import TooltipComp from '@app/sharedComponents/ToolTip/Tooltip';
import TooltipRevamp from '@app/sharedComponents/ToolTip/TooltipRevamp';
import { ColorTokens } from '@voltmoney/schema';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { endpoints } from '@app/api/apis';
import { useState } from 'react';
import axios from 'axios';
import { useDispatch } from 'react-redux';
import { updateLinkedApplication } from '@app/store/slices/authSlice';
import handleApiErr from '@app/helper/handleApiErr';
import { showErrorSheet } from '@app/store/slices/errorSlice';
import { getNextRoute } from '@app/navigationApp/navigationUtil';
import { useDarkMode } from '@app/utils/utils';
import fetchUserDetails from '@app/helper/fetchUserInfo';
import { getEnabledRTA } from '@app/screens/KYCStepper/services/service';

const CreditInfoCard = ({isLoanExpiringToday,lendingPartnerId,creditInfo,navigation,pendingRequestInfo,enableToFuFlag,activeEnhancementApplication,manageLimitConfigForLender}) => {
  const isDarkMode = useDarkMode()
    const {availableCreditAmount,principalOutStandingAmount} = creditInfo || {} ;
    const isIncreaseLimitEnabled = manageLimitConfigForLender?.increaseLimitAllowed;
    // const isIncreaseLimitEnabled = true;
    const dispatch = useDispatch()

    const [isIncreaseLimitLoading,setIsIncreaseLimitLoading] = useState(false);

    const {enable_direct_fetch} = useAppSelector((state) => state.firebaseParams);
    // const enable_direct_fetch = true;

    const isEnhancementApplicationInProgress = activeEnhancementApplication && Object.keys(activeEnhancementApplication)?.length > 0;
    const showEnhancementMessage = isEnhancementApplicationInProgress && activeEnhancementApplication?.messageForUserToDisplay !== '' && activeEnhancementApplication?.messageForUserToDisplay !== null;

    const withdrawAction = ()=>{
      navigation.navigate(ROUTE.WITHDRAW_AMOUNT,{creditInfo})
    }

    const repayAction = ()=>{
      navigation.navigate(ROUTE.FLEXI_PAY,{creditInfo})
    }
    const logo = (id) => {
      const logoObj ={
      tata: <TataLogo/>,
      bajaj: <BajajLogo/>,
      dsp: <DSPLogo color={isDarkMode ? '#fff': '#000'}/>,
      }
      return logoObj[id]
  }
    const imageUrl = lendingPartnerId === 'DSP' ? 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/dsp_round_bg.png' : 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/bajaj_round_bg.png';


    const fetchNewApplication = async()=>{
      const payload =    {
        creditApplicationType: "CREDIT_MODIFICATION_AGAINST_SECURITIES",
    }
      const creditId = creditInfo?.creditId;
      const url = endpoints.enhanceLimit + creditId + '/v2'
      setIsIncreaseLimitLoading(true);
      try{
        const res = await axios.post(url,payload);
        const applicationId = res?.data?.applicationId;
        AsyncStorage.setItem("application_id", applicationId);
        AsyncStorage.setItem("is_from_enhance_limit", "true");
        AsyncStorage.setItem("currentStepId", res?.data?.currentStepId);
        AsyncStorage.setItem('newUserData', JSON.stringify(res?.data))
        let route = 'MANAGE_LIMIT_LANDING';
        let enabledRTA = null;
        // await fetchUserDetails();
        if(isEnhancementApplicationInProgress){
          const updatedApplicationResponse = await axios.get(`${endpoints.borrowerApplication}${applicationId}`);
          const currentStepId = updatedApplicationResponse.data.currentStepId;
          enabledRTA = await getEnabledRTA({
            applicationId: updatedApplicationResponse?.data?.applicationId
          })
          route = getNextRoute(
              currentStepId, 
              updatedApplicationResponse.data.applicationState, 
              updatedApplicationResponse.data.stepStatusMap,
              enabledRTA?.enabledRtaFlow
          );
        } else {
          route = 'MF_FETCH_PORTFOLIO';
        }
        enable_direct_fetch === 'true' ? navigation.navigate(route,{isEnhancementApplicationInProgress : true}) :   navigation.navigate("MANAGE_LIMIT_LANDING");
        dispatch(updateLinkedApplication(res?.data))
      } catch(err: any){
        console.log('newApplication',err);
        if(handleApiErr(err)){
          dispatch(
            showErrorSheet({
              isErrorSheetVisible: true,
              errorMessage: err?.data?.message || 'Something went wrong',
              closeOnBackdropPress: true,
              errorType: err?.data?.voltErrorCode || err?.data?.statusCode,
              errorHeading: err?.data?.header,
              btnName: 'Ok, got it!'
            }),
          );
        }
      } finally {
        setIsIncreaseLimitLoading(false);
      }
    }

  const handleIncreaseLimit = async()=>{
    await AsyncStorage.removeItem('isElevate')
    await fetchNewApplication()
  }

  const renderEnhancementMessage = () => {
    return (
      <ThemedView my='sm' mx='md' bg='bg-fill-emphasis-secondary' borderRadius='xs' alignItems='center' justifyContent='center' alignSelf='center'>
        <ThemedView
          px='md'
          py='xs'
          bg='bg-fill-emphasis-secondary' 
          borderRadius='xs'
        >
          <ThemedText variant='b4s' color='text-success'>  
            {activeEnhancementApplication?.messageForUserToDisplay}
          </ThemedText>
        </ThemedView>
        <View
          style={{
            position: 'absolute',
            bottom: -12,     
            left: 16,         
            width: 0,
            height: 0,
            borderLeftWidth: 8,
            borderRightWidth: 8,
            borderTopWidth: 12,
            borderLeftColor: 'transparent',
            borderRightColor: 'transparent',
            borderTopColor: themeColorSet['bg-fill-emphasis-secondary'], 
          }}
        />
      </ThemedView>
    );
  };
  




  return(
      enableToFuFlag ? 
      <>
        <ThemedView mx='lg' mt='2xl' borderColor='border-primary' backgroundColor='bg-surface-primary' borderWidth={1} borderRadius='lg'>
            <ThemedView pt='2xl' justifyContent='center' alignItems='center'>
              <ThemedText variant='b4r' color='text-secondary'>
                  Available limit
              </ThemedText>
              <ThemedView flexDirection='row' alignItems='center' mt='xs'>
                  <ThemedText color='text-emphasis-secondary'  variant='l1'>₹</ThemedText>
                  <ThemedText color='text-emphasis-secondary'  variant='h1b'>
                    {formatIndianCurrency(Math.floor(availableCreditAmount))}
                  </ThemedText>
              </ThemedView>
            </ThemedView>
            {isIncreaseLimitEnabled &&showEnhancementMessage && renderEnhancementMessage()}
            {isIncreaseLimitEnabled  ? <ThemedView pt='md' px='lg' flexDirection='row' width='100%' flex={1}>
              <ThemedView pr='xs' width={'50%'}>
                <Button 
                  type='OUTLINED' 
                  label= {isIncreaseLimitLoading ? 'Fetching' : isEnhancementApplicationInProgress ? 'Unlock new limit' : 'Increase limit' }
                  eventName="ENHANCE_LIMIT_BUTTON" 
                  additionalProperties={{
                    page : 'home'
                  }}
                  handlePress={handleIncreaseLimit} 
                  buttonLoader={isIncreaseLimitLoading}
                  disabled={false} 
                /> 
              </ThemedView>
              <ThemedView pl='xs' width={'50%'}>  
                <Button 
                  type='SOLID' 
                  label='Withdraw' 
                  eventName="WITHDRAW_BUTTON"
                  handlePress={withdrawAction} 
                  disabled={pendingRequestInfo?.disbursalDetailsList?.length>0 || availableCreditAmount<=0 || isLoanExpiringToday } 
                />
              </ThemedView>
            </ThemedView> : 
              <ThemedView pt='md' px='lg' width={'100%'}>  
                <Button 
                  type='SOLID' 
                  label='Withdraw' 
                  eventName="WITHDRAW_BUTTON"
                  handlePress={withdrawAction} 
                  disabled={pendingRequestInfo?.disbursalDetailsList?.length>0 || availableCreditAmount<=0 || isLoanExpiringToday } 
                />
              </ThemedView>
            }
            <ThemedView mt='lg' borderColor='border-primary' borderTopWidth={1}/>
            <ThemedView m='sm' py='sm' px='md' backgroundColor='bg-fill-secondary' borderWidth={1} borderBottomRightRadius='sm' borderBottomLeftRadius='sm' borderColor='bg-fill-secondary'>
              <ThemedView flexDirection='row' justifyContent='space-between' alignItems='center'>
                <ThemedView>
                  <ThemedText variant='b4r' color='text-secondary'>
                    Outstanding amount
                  </ThemedText>
                  <ThemedView flexDirection='row' mt='xs'>
                    <ThemedText color='text-primary'  variant='l5' >₹</ThemedText>
                    <ThemedText color='text-primary'  variant='h5s'>
                    {formatIndianCurrency(principalOutStandingAmount??0)}
                    </ThemedText>
                  </ThemedView>
                </ThemedView>
                <ThemedView flexDirection='row' justifyContent='flex-end'>
                  <Button 
                    disabled={principalOutStandingAmount<=0}  
                    type="TEXT" handlePress={repayAction}
                    label="Repay" showRightAccessory={true} 
                    rightAccessory={()=> <CaretRight size="16" color={principalOutStandingAmount<=0 ? themeColorSet['text-disabled'] : themeColorSet['text-action-primary']} />}
                  />
                </ThemedView>
              </ThemedView>
            </ThemedView>
        </ThemedView>
      </> :
      <>
        <ThemedView mx='lg' mt='2xl' borderColor='border-primary' backgroundColor='bg-surface-primary' borderWidth={1} borderRadius='lg' style={[]} >
          <Image style={{ height: 96, width: 140, position: 'absolute' , right : 0, top:0, borderTopRightRadius:16 }} source={{ uri: imageUrl }} />
            <ThemedView  p='lg'>
              <ThemedText color='text-secondary'  variant='b4r' pb='2xs' >
                Available cash with {LENDER_DISPLAY_NAME_MAP[lendingPartnerId]}
              </ThemedText>
              <ThemedView  flexDirection='row' alignItems='center' pb='sm'>
              <ThemedText color='text-emphasis-secondary'  variant='l1'>₹</ThemedText>
              <ThemedText color='text-emphasis-secondary'  variant='h1b' style={{marginTop:Platform.OS === 'ios' ? 4: 0}}  >
                {formatIndianCurrency(Math.floor(availableCreditAmount))}
              </ThemedText>
              </ThemedView>
            </ThemedView>
            <ThemedView p='lg' py="md" flexDirection='row' justifyContent='space-between' borderTopColor='border-primary' borderTopWidth={1}>
              <ThemedView>
                <ThemedText color='text-secondary'  variant='b4r' pb='2xs'  >
                  Outstanding amount
                </ThemedText>
                <ThemedView flexDirection='row' alignItems= {Platform.OS === 'ios' ? 'center' : 'baseline'} mb='sm'>
                  <ThemedText color='text-primary'  variant='l5' >₹</ThemedText>
                  <ThemedText color='text-primary'  variant='h5b'>
                  {formatIndianCurrency(principalOutStandingAmount??0)}
                  </ThemedText>
                </ThemedView>
              </ThemedView>
              <ThemedView alignItems='flex-end'>
                <ThemedText color='text-secondary' variant='b4r' mb="xs">Lender</ThemedText>
                {logo(lendingPartnerId?.toLowerCase())}
              </ThemedView>
            </ThemedView>
          </ThemedView>
          <ThemedView px='lg' flex={1} flexDirection='row' justifyContent='space-between' alignItems='center' mt='md' width={'100%'}>
            <ThemedView pr='xs' width={'50%'}>
              <Button type="OUTLINED" label="Repay" handlePress={repayAction} disabled={principalOutStandingAmount<=0} />
            </ThemedView>
            <ThemedView  width={'50%'} pl='xs'>
              <Button type='SOLID' label='Withdraw' eventName="WITHDRAW_BUTTON" handlePress={withdrawAction} disabled={pendingRequestInfo?.disbursalDetailsList?.length>0 || availableCreditAmount<=0 || isLoanExpiringToday } />
            </ThemedView>
        </ThemedView>
      </>
  )
}

export default CreditInfoCard;